import { render } from "./GeotargetBlock.vue?vue&type=template&id=982c54c8"
import script from "./GeotargetBlock.vue?vue&type=script&lang=js"
export * from "./GeotargetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/GeotargetBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "982c54c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('982c54c8', __exports__)) {
    api.reload('982c54c8', __exports__)
  }
  
  module.hot.accept("./GeotargetBlock.vue?vue&type=template&id=982c54c8", () => {
    api.rerender('982c54c8', render)
  })

}


export default __exports__